<template>
  <layout-popup
      v-model="isOpen"
      ref="passwordLayerPopUp"
      :titleName="$t('cmn.changingPassword')"
      :confirmEvt="onConfirm"
      :footerBtn="['confirm', 'cancel']"
      :content-css="{minWidth: width, minHeight: height}"
      @hide="onHide"
    >
      <div>
        <div class="content-group">
          <div class="contents-row textRef">
            <table class="bs-table table-bordered-none">
              <colgroup>
                <col width="40px"/>
                <col width="auto"/>
              </colgroup>
              <tbody>
                <tr>
                  <td><span class="ps-icon ps-icon-notice"></span></td>
                  <td v-if="ccFlag">
                    <div>{{$t('cmn.commonPwTooltip1_cc')}}</div>
                    <div>{{$t('cmn.commonPwTooltip2_cc')}}</div>
                  </td>
                  <td v-else>{{$t('sm.administrator_popup_tooltip_pwd1')}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>{{$t('sm.administrator_popup_tooltip_pwd2')}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>{{$t('sm.administrator_popup_tooltip_pwd3')}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>{{$t('sm.administrator_popup_tooltip_pwd4')}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>{{$t('sm.administrator_popup_tooltip_pwd5')}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td>{{$t('sm.administrator_popup_tooltip_pwd6')}}</td>
                </tr>
              </tbody>
            </table>
            <!--<div class="marB15">-->
              <!--<span class="ps-icon ps-icon-notice"></span>-->
              <!--&lt;!&ndash;영문자와 숫자, 특수문자 (!@#$%&*^)를 모두 혼용하여 9~12자로 작성해 주세요.&ndash;&gt;-->
            <!--</div>-->

            <!--&lt;!&ndash; TAMS 오리지널 &ndash;&gt;-->
            <!--&lt;!&ndash;아이디가 포함되지 않도록 합시다.<br/>&ndash;&gt;-->
            <!--&lt;!&ndash;개인정보 (사번, 전화번호 등)를 이용한 비밀번호는 사용할 수 없습니다.<br/>&ndash;&gt;-->
            <!--&lt;!&ndash;같은 문자를 3번 이상 반복할 수 없습니다.<br/>&ndash;&gt;-->
            <!--&lt;!&ndash;연속되는 숫자를 3자리 이상 사용할 수 없습니다.&ndash;&gt;-->

            <!--&lt;!&ndash;9자 이상 32자 이하의 영문, 숫자, 특수문자 조합&ndash;&gt;-->
            <!--&lt;!&ndash;ID와 비밀번호가 3자리 이상 일치할 수 없음&ndash;&gt;-->
            <!--&lt;!&ndash;ID역순 패스워드 사용 불가&ndash;&gt;-->
            <!--&lt;!&ndash;Well-Known Word('admin', 'administrator', 'test', 'qwe', 'user') 사용 불가&ndash;&gt;-->
            <!--<div>{{$t('sm.administrator_popup_tooltip_pwd1')}}</div>-->
            <!--<div>{{$t('sm.administrator_popup_tooltip_pwd2')}}</div>-->
            <!--<div>{{$t('sm.administrator_popup_tooltip_pwd3')}}</div>-->
            <!--<div>{{$t('sm.administrator_popup_tooltip_pwd4')}}</div>-->
          </div>
          <div class="contents-row">
            <!-- 테이블 시작 -->
            <table class="bs-table table-bordered-none">
              <colgroup>
                <col width="115px"/>
                <col width="auto"/>
              </colgroup>
              <tbody>
                <tr v-if="myAccountSettings || adminGeneral.admin_type === 3 || loginAdminType !== 3">
                  <td class="td-head">{{ $t('cmn.currentPassword') }} <span class="textR">*</span></td>
                  <td>
                    <q-input v-model="password"
                             type="password"
                             name="password"
                             no-pass-toggle
                             :maxLength="32"
                             data-vv-scope="main"
                             v-validate="'required'"
                             :error="errors.has('main.password')"
                             @keydown.enter="onConfirm"
                             class="bs bs-q-input bs-q-input-default"
                             style="width:100%;" >
                    </q-input>
                  </td>
                </tr>

                <tr>
                  <td class="td-head">{{ $t('cmn.newPassword') }} <span class="textR">*</span></td>
                  <td>
                    <q-input v-model="newPassword"
                             type="password"
                             name="newPassword"
                             no-pass-toggle
                             :maxLength="32"
                             data-vv-scope="main"
                             v-validate="`required|${ccFlag ? `isValidAdminPasswdCc:${adminUname}|isValidNotChainKeyboard` : `isValidAdminPasswd:${adminUname}`}`"
                             :error="errors.has('main.newPassword')"
                             @keydown.enter="onConfirm"
                             class="bs bs-q-input bs-q-input-default"
                             style="width:100%;" >
                    </q-input>
                  </td>
                </tr>

                <tr>
                  <td class="td-head">{{ $t('cmn.newPasswordCheck') }} <span class="textR">*</span></td>
                  <td>
                    <q-input v-model="reNewPassword"
                             type="password"
                             name="reNewPassword"
                             no-pass-toggle
                             :maxLength="32"
                             data-vv-scope="main"
                             v-validate="'required|isValidPasswdRepeatAllWord:' + passwordForValidate"
                             :error="errors.has('main.reNewPassword')"
                             @keydown.enter="onConfirm"
                             class="bs bs-q-input bs-q-input-default"
                             style="width:100%;" >
                    </q-input>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- 테이블 끝 -->
          </div>
        </div>
      </div>
    <validate-dialog ref="validateDialog">
    </validate-dialog>
    </layout-popup>
</template>
<script>
  import LayoutModalPopUp from '~/components/popUp/LayoutModalPopUp'
  import ValidateDialog from '~/components/dialog/ValidateDialog'
  import { encryptionPassword } from '~/utils/cryptoHelper'

  import { createNamespacedHelpers } from 'vuex'

  const { mapState, mapActions } = createNamespacedHelpers('system/adminSettings/adminGroupSettings')
  const { mapState: mapStateMyAccountSettings, mapActions: mapActionsMyAccountSettings } = createNamespacedHelpers('common/myAccountSettings')

  export default {
    name: 'PasswordChangePopup',
    components: {
      'layout-popup': LayoutModalPopUp,
      ValidateDialog
    },
    props: {
      // 내 정보 보기 모드
      myAccountSettings: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isOpen: false,
        password: '',
        newPassword: '',
        reNewPassword: '',
        width: '530px',
        adminUname: ''
      }
    },
    computed: {
      ...mapState([
        'postManagersPwdResult',
        'adminGeneral'
      ]),
      ...mapStateMyAccountSettings([
        'myAccountInfo'
      ]),
      encryptionAesKey () {
        return this.$store.state.common.authenticate.encryptionAesKey
      },
      loginAdminType () {
        return this.$store.state.common.common.uiData.user.admin_type
      },
      passwordForValidate () {
        return this.newPassword.replace(/,/gi, 'COMMA').replace(/\|/gi, 'PIPE')
      },
      ccFlag () {
        return this.$store.state.common.common.uiData.system.cc_flag
      },
      height () {
        let h = (this.myAccountSettings || this.adminGeneral.admin_type === 3 || this.loginAdminType !== 3) ? 401 : 365
        if (this.ccFlag) { h += 20 }

        return `${h}px`
      }
    },
    methods: {
      ...mapActions([
        'acsPostManagersPwd'
      ]),
      ...mapActionsMyAccountSettings([
        'editMyAccountPasswd'
      ]),
      show () {
        this.password = ''
        this.newPassword = ''
        this.reNewPassword = ''
        this.adminUname = this.myAccountSettings ? this.myAccountInfo.admin_login_uname : this.adminGeneral.admin_name
        // this.height = (this.myAccountSettings || this.adminGeneral.admin_type === 3 || this.loginAdminType !== 3) ? '371px' : '335px'
        this.$refs.passwordLayerPopUp.show()
        this.validatorClear()
      },
      hide () {
        this.$refs.passwordLayerPopUp.hide()
      },
      onHide () {
        this.validatorClear()
        this.$emit('hide')
      },
      async onConfirm () {
        const check = await this.validateMixins('main')
        if (!check) {
          return
        }

        let result = ''
        if (this.myAccountSettings) { // 계정 추가
          // 동일 비밀번호 체크 (상황별)
          if (this.password === this.newPassword) {
            this.$alertPopUp.show(this.$t('msg.sameNewPasswd'))
            return
          }

          const params = {
            cur_login_pw: encryptionPassword(this.encryptionAesKey, this.password),
            new_login_pw: encryptionPassword(this.encryptionAesKey, this.newPassword),
            secui_helper_key: this.encryptionAesKey
          }

          result = await this.editMyAccountPasswd(params)
        } else { // 비밀번호 변경
          const payload = {admin_id: this.adminGeneral.admin_id}
          if (this.adminGeneral.admin_type === 3 || this.loginAdminType !== 3) {
            // 동일 비밀번호 체크 (상황별)
            if (this.password === this.newPassword) {
              this.$alertPopUp.show(this.$t('msg.sameNewPasswd'))
              return
            }

            payload.password = {
              cur_login_pw: encryptionPassword(this.encryptionAesKey, this.password),
              new_login_pw: encryptionPassword(this.encryptionAesKey, this.newPassword),
              secui_helper_key: this.encryptionAesKey
            }
          } else {
            payload.password = {
              new_login_pw: encryptionPassword(this.encryptionAesKey, this.newPassword),
              secui_helper_key: this.encryptionAesKey
            }
          }
          result = await this.acsPostManagersPwd(payload)
        }
        if (result.code !== 'ok') {
          this.$alertPopUp.show(result.errors)
          return
        }
        this.$alertPopUp.show(this.$t('msg.updateApply'))
        this.$refs.passwordLayerPopUp.hide()
      }
    }
  }
</script>

